import styles from './header.module.scss';
import Descriptor from '../descriptor/descriptor';
import HeaderPhone from '../header-phone/header-phone';
import { appConfig } from '../../../config/app.config';
import { HeaderLogo } from '../header-logo/header-logo';
import { HeaderContent } from '../../../interfaces/header-content.interface';
import { memo, useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../root/theme.context';
import { Theme } from '../../../enums/theme.enum';
import { useDefineStatusByDisplayMode } from '../../../hooks/use-define-status-by-display-mode.hook';
import { QuizHistoryService } from '../../../services/history.service';

interface HeaderProps {
	active: boolean
	data: HeaderContent,
	historyService: QuizHistoryService
}

export const Header = memo((props:HeaderProps) => {
	const { theme } = useContext(ThemeContext);
	const { data: { logo, dark_theme_logo, descriptor, phone, link, phoneDisplayMode }, historyService} = props;
	const showPhone = useDefineStatusByDisplayMode(phoneDisplayMode);
	const [logoUrl, setLogoUrl] = useState(logo?.url);

	useEffect(() => {
		switch(theme) {
			case Theme.AQUA_MAGENTA:
			case Theme.DARK: setLogoUrl(dark_theme_logo?.url);
				break;
			default: setLogoUrl(logo?.url);
		}
	}, [logo, dark_theme_logo]);
  
	return (
		<header className={styles.header}>
      {(logo || descriptor) && 
        <div className={styles.leftSide}>
          {(logo || dark_theme_logo ) && <HeaderLogo link={link} src={appConfig().assets_url + logoUrl}/>}
          <Descriptor value={descriptor}/>
        </div>
      }

			{(phone && showPhone) &&
        <div className={styles.rightSide}>
					<HeaderPhone phone={phone} mode={"mobile"} historyService={historyService}/>
			  </div>
			}
		</header>
	);
});